import { get } from 'es-toolkit/compat';
import * as React from 'react';
import { FieldProps } from 'formik';

import { Radiobutton } from './Radiobutton';

interface Props extends FieldProps {
  className?: string;
  label: string;
  id?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 */
export class FormikRadiobutton extends React.Component<Props> {
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { field, onChange } = this.props;

    field.onChange(event);

    if (onChange) {
      onChange(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { field, onBlur } = this.props;

    field.onBlur(event);

    if (onBlur) {
      onBlur(event);
    }
  };

  render() {
    const {
      field,
      form: { touched, errors },
      label,
      className,
      id,
      ...props
    } = this.props;

    const hasError = !!(get(touched, field.name) && get(errors, field.name));

    return (
      <Radiobutton
        id={id}
        checked={field.value === id}
        label={label}
        className={className}
        hasError={hasError}
        error={get(errors, field.name)}
        {...field}
        {...props}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
      />
    );
  }
}
